import { DialogComponent } from '@theme/dialog';
import { CartAddEvent } from '@theme/events';

/**
 * Promo dialog that opens whenever a product is added to the cart,
 * advertising the automatic ₪50 hoodie discount.
 *
 * @extends {DialogComponent}
 */
class PitchUpsellDialog extends DialogComponent {
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CartAddEvent.eventName, this.#handleCartAdd);
  }

  /** @param {Event} event */
  #handleCartAdd = (event) => {
    if (!(event instanceof CartAddEvent)) return;
    if (event.detail?.data?.didError) return;

    // Skip the promo if the item just added is already one of the hoodies.
    const addedProductId = String(event.detail?.data?.productId ?? '');
    const hoodieIds = (this.getAttribute('data-hoodie-ids') || '').split(',').filter(Boolean);
    if (addedProductId && hoodieIds.includes(addedProductId)) return;

    this.showDialog();
  };
}

if (!customElements.get('pitch-upsell-dialog')) {
  customElements.define('pitch-upsell-dialog', PitchUpsellDialog);
}
